import Vue from 'vue'
import Vuex from 'vuex'
import _ from 'lodash'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    config: {
      id: '5',
      // url: 'http://192.168.31.102/',
      // url: 'http://buyhunter.io/',
      url: 'http://buyhunter.ru/',
      get_api: 'getApiKey/',
      api_url: 'api/mobile-app/',
      products: '/products',
      orders: '/postOrder',
      img_url: 'images/products/'
    },
    cart: [],
    categories: [],
    sales: [],
    slider: [],
    shippings: [],
    pickups: [],
    payments: [],
    payment: {},
    info: {},
    deliverys: '',
    orderProp: {
      sale: '',
      margin: '',
      min_price: ''
    }
  },
  mutations: {
    updateCart (state, data) {
      state.cart = []
    },
    updateOrderProp(state, data) {
      state.orderProp = data.props;
    },
    deliverys (state, data) {
      state.deliverys = data.data
    },
    api (state, api) {
      if (api.categories) {
        api.categories.forEach(function (item) {
          state.categories.push(item)
        })
      }
      state.payments = api.payments
      state.pickups = api.pickups
      state.shippings = api.shippings
      state.info = api.info
      if (api.slider) {
        api.slider.forEach(function (item) {
          state.slider.push(state.config.url + state.config.img_url + state.config.id + '/' + item.image)
        })
      }
      state.sales = api.sales
    },
    addtocart (state, product) {
      state.cart.unshift({
        id: product.product.id,
        name: product.product.name,
        price: product.product.price,
        image: product.product.image,
        qty: 1
      })
    },
    inc (state, id) {
      var found = _.find(state.cart, ['id', id.id])
      if (typeof found === 'object') {
        found.qty++
      }
    },
    dec (state, id) {
      var found = _.find(state.cart, ['id', id.id])
      if (typeof found === 'object') {
        if (found.qty === 1) {
          const product = state.cart.find(product => {
            return product.id === id.id
          })
          state.cart.splice(state.cart.indexOf(product), 1)
        } else {
          found.qty--
        }
      }
    },
    del (state, id) {
      var found = _.find(state.cart, ['id', id.id])
      if (typeof found === 'object') {
        const product = state.cart.find(product => {
          return product.id === id.id
        })
        state.cart.splice(state.cart.indexOf(product), 1)
      }
    }
  },
  actions: {
    updateDeliversys_IdAction ({
      commit
    }, shippingId) {
      commit('UpdateDeliverys_id', shippingId)
    },
    updatePaymentAction ({
      commit
    }, payment) {
      commit('UpdatePayment', payment)
    },
  }
})



// WEBPACK FOOTER //
// ./src/storage.js